// @flow
import React, { Component } from 'react';

import './Loader.css';


export default class Loader extends Component {

    render () {
        return (
            <div className="ln-loader">
                <div className="ln-dots">
                    <div className="ln-dot-1"></div>
                    <div className="ln-dot-2"></div>

                    <br/>
                    { this.props.message }
                </div>
            </div>)
    }

}



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js